import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { settingsService, Settings } from "../services/firebase";
import FacebookLogo from "../assets/icone/FacebookLogo";
import InstagramLogo from "../assets/icone/InstagramLogo";
import WhatsappLogo from "../assets/icone/WhatsappLogo";
import FacebookLogoMoblie from "../assets/icone/FacebookLogoMoblie";
import FacebookLogoTablet from "../assets/icone/FacebookLogoTablet";
import WhatsappLogoMoblie from "../assets/icone/WhatsappLogoMoblie";
import WhatsappLogoTablet from "../assets/icone/WhatsappLogoTablet";
import InstagramLogoMoblie from "../assets/icone/InstagramLogoMoblie";
import InstagramLogoTablet from "../assets/icone/InstagramLogoTablet";

import "./SocialIcons.css";

interface SocialIconsProps {
  className?: string;
  forceDesktop?: boolean;
}

const SocialIcons: React.FC<SocialIconsProps> = ({
  className,
  forceDesktop = false,
}) => {
  const { i18n } = useTranslation();
  const [settings, setSettings] = useState<Settings>({
    siteName: "",
    siteDescription: "",
    contactEmail: "",
    contactPhone: "",
    socialMedia: {},
  });
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const data = await settingsService.get();
        setSettings(data);
      } catch (error) {
              }
    };

    fetchSettings();
  }, []);

  useEffect(() => {
    const checkScreenSize = () => {
      const width = window.innerWidth;
      setIsMobile(width >= 390 && width <= 809);
      setIsTablet(width >= 810 && width <= 1279);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const handleFacebookClick = () => {
    if (settings.socialMedia.facebook) {
      window.open(
        settings.socialMedia.facebook,
        "_blank",
        "noopener,noreferrer"
      );
    } else {
      alert("לא הוגדר קישור לפייסבוק. אנא הגדר קישור בהגדרות האתר.");
    }
  };

  const handleInstagramClick = () => {
    if (settings.socialMedia.instagram) {
      window.open(
        settings.socialMedia.instagram,
        "_blank",
        "noopener,noreferrer"
      );
    } else {
      alert("לא הוגדר קישור לאינסטגרם. אנא הגדר קישור בהגדרות האתר.");
    }
  };

  const handleWhatsAppClick = () => {
    if (settings.contactPhone) {
      const phoneNumber = settings.contactPhone
        .replace(/\s+/g, "")
        .replace(/[^\d+]/g, "");
      const whatsappUrl = `https://wa.me/${phoneNumber}`;
      window.open(whatsappUrl, "_blank", "noopener,noreferrer");
    } else {
      alert("לא הוגדר מספר טלפון. אנא הגדר מספר טלפון בהגדרות האתר.");
    }
  };

  return (
    <div className={`social-icons-container ${className || ""}`}>
      <a
        className={`social-icon-link ${
          !settings.contactPhone ? "disabled" : ""
        } ${i18n.language === "he" ? "rtl" : "ltr"}`}
        onClick={handleWhatsAppClick}
        title={
          settings.contactPhone
            ? `וואטסאפ - ${settings.contactPhone}`
            : "לא הוגדר מספר טלפון"
        }
      >
        {!forceDesktop && isMobile ? <WhatsappLogoMoblie /> : !forceDesktop && isTablet ? <WhatsappLogoTablet /> : <WhatsappLogo />}
      </a>
      <a
        className={`social-icon-link ${
          !settings.socialMedia.instagram ? "disabled" : ""
        } ${i18n.language === "he" ? "rtl" : "ltr"}`}
        onClick={handleInstagramClick}
        title={
          settings.socialMedia.instagram
            ? "אינסטגרם"
            : "לא הוגדר קישור לאינסטגרם"
        }
      >
        {!forceDesktop && isMobile ? (<InstagramLogoMoblie />) : !forceDesktop && isTablet ? <InstagramLogoTablet /> : <InstagramLogo /> }
      </a>
      <a
        className={`social-icon-link ${
          !settings.socialMedia.facebook ? "disabled" : ""
        } ${i18n.language === "he" ? "rtl" : "ltr"}`}
        onClick={handleFacebookClick}
        title={
          settings.socialMedia.facebook ? "פייסבוק" : "לא הוגדר קישור לפייסבוק"
        }
      >
        {!forceDesktop && isMobile ? <FacebookLogoMoblie /> : !forceDesktop && isTablet ? <FacebookLogoTablet /> : <FacebookLogo />}
      </a>
    </div>
  );
};

export default SocialIcons;
